import { getCurrentUser } from '@/utils/auth.util'
import * as Sentry from '@sentry/react'
import { useEffect } from 'react'

export default function useGetCurrentUser() {
  const user = getCurrentUser()

  useEffect(() => {
    if (!user) return
    Sentry.setUser(user)
  }, [user])

  return user
}
